module.exports = __webpack_public_path__ + "static/img/open-title-2.d42af9f6.png";